// extracted by mini-css-extract-plugin
export default {"mainContainer":"EntityRating_mainContainer__XRnV2","icon":"EntityRating_icon__CyDfa","rating":"EntityRating_rating__PRRv9","reviews":"EntityRating_reviews__l1lD5"};